import { EntraUser } from "../../../profileService/model/entraUser/EntraUser";

export interface UARFields {
    user: EntraUser;
    locations?: string[];
  };

export function DefaultTicketUARFields(): UARFields {
    return {
        user: new EntraUser(),
        locations: [],
    };
}